import React from 'react';

import _ from 'lodash';
import { connect } from 'react-redux';

import { InputMoney } from '@nerdwallet/currency';
import num from '@nerdwallet/nw-client-lib/num';

import { AMORTIZATION } from '../../../lib/analytics-constants';
import { validationsSelector } from '../../../lib/selectors';
import { inputsSelector } from '../../../lib/selectors/amortization-calculator-selector';
import {
  AmortizationInput,
  inputOnChange,
  INPUT_TRACKING_TYPES,
} from '../../../lib/utils';

type OnChangeEvent = React.ChangeEvent<HTMLInputElement>;

const DownPaymentInput: React.FC<AmortizationInput> = ({
  inputs,
  dispatch,
  analytics,
  validations,
  label = '',
  tooltip = '',
  className = '',
  fullWidth,
}) => {
  const value = !_.isNil(inputs?.downPayment)
    ? num.formatCurrency(inputs?.downPayment)
    : '';
  const errorMessage = validations?.downPayment?.[0];
  const error = Boolean(errorMessage);
  const analyticsEnabled = analytics && analytics?.enabled;
  const legacyAnalytics =
    analyticsEnabled && analytics?.payload?.legacy?.formName;
  const bedrockAnalytics =
    analyticsEnabled && analytics?.payload?.bedrock?.eventType;

  const onInputChange = (e: OnChangeEvent) => {
    let legacy;
    if (legacyAnalytics) {
      const legacyProps = analytics?.payload?.legacy;
      legacy = {
        ...legacyProps,
        fieldName: 'downPayment',
        inputType: INPUT_TRACKING_TYPES.TEXT,
      };
    }

    let bedrock;
    if (bedrockAnalytics) {
      const bedrockProps = analytics?.payload?.bedrock;
      bedrock = {
        ...bedrockProps,
        valueFieldName: 'value_i',
      };
    }

    inputOnChange({
      event: e,
      dispatch,
      legacy,
      bedrock,
      fieldName: 'downPayment',
      calculator: AMORTIZATION,
      inputType: 'currency',
      additionalInputIdsToValidate: ['purchasePrice'],
    });
  };

  const downPaymentLabel = (formatType?: string) => {
    const downPayment = inputs?.downPayment / inputs?.purchasePrice;
    if (formatType === 'percent') {
      if (!_.isFinite(downPayment)) return '-';
      return num.formatPercent(downPayment, '0%');
    }
    return num.formatCurrency(downPayment);
  };

  return (
    <InputMoney
      label={`${label} (${downPaymentLabel('percent')})`}
      value={value}
      placeholder={downPaymentLabel()}
      error={error}
      errorMessage={errorMessage}
      onChange={onInputChange}
      tooltip={tooltip}
      className={className}
      fullWidth={fullWidth}
    />
  );
};

const mapStateToProps = (state) => ({
  inputs: inputsSelector(state),
  validations: validationsSelector(state),
});

export default connect(mapStateToProps)(DownPaymentInput);
